import React from "react"
import { Paper, Popper } from "@mui/material"

interface PopupMessageWrapperProps {
    open: boolean;
    children: React.ReactNode;
    coverage?: number
    width?: number
    height?: number
    maxHeight?: number
}

export const PopupMessageWrapper = ({ open, children, coverage, width, height, maxHeight}: PopupMessageWrapperProps) => {
    return (
        <Popper
            open={open}
            sx={{
                padding: 0,
                margin: 0,
                width: "100%",
                height: "100%",
                zIndex: 1400,
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    padding: 3,
                    width: coverage ? `${coverage}dvw` : width ? `${width}dvw` : 'max-content',
                    height: coverage ? `${coverage}dvh` : height ? `${height}dvh` : 'auto',
                    maxWidth: '80dvw',
                    maxHeight: maxHeight ? `${maxHeight}dvh` : '80dvh',
                    backgroundColor: 'sepia.background',
                    border: '1px solid',
                    borderColor: 'sepia.extraLight',
                    borderRadius: 3,
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
                }}
            >
                {children}
            </Paper>
        </Popper>
    )
}